// types
type Types = any;

const listItem: Types = {
  defaultProps: {
    disableGutters: true
  },

  styleOverrides: {
    root: {
      paddingTop: 0,
      paddingBottom: 0
    }
  }
};

export default listItem;
